// Placeholder prices (missing or <= 0.01) are treated as "no price" → show label.
export const isPlaceholderPrice = (p) => p == null || Number(p) <= 0.01;

// Resolve the label to display when there is no real numeric price.
export const priceLabel = (product, settings) =>
  product?.custom_price_label || settings?.global_price_label || "Prezzo su consulenza";
